import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react'
import { Collapse } from '@mui/material'
import { default as Comments } from '../../Base/Form/TextArea'
import { z } from 'zod'
import * as lib from '../../../../js/lib/lib.js'

export const commentsSectionSchema = (dictionary) =>
  z.object({
    comments: z
      .string()
      .max(250, dictionary.commentsMaxLengthText)
      .optional()
      .or(z.literal('')),
  })

const CommentsSection = forwardRef(({ control, errors }, ref) => {
  const { dictionary } = window.bookingData || window.modifyData
  const [collapseOpen, setCollapseOpen] = useState(true)

  useImperativeHandle(ref, () => ({
    expand: () => {
      setCollapseOpen(true)
    },
  }))

  const handleCollapseClick = () => {
    if (lib.scrDevices()) {
      setCollapseOpen(!collapseOpen)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (!lib.scrDevices()) {
        setCollapseOpen(true)
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div className="s-booking-form__form-group">
      <div
        className="row"
        role="button"
        tabIndex={0}
        onClick={handleCollapseClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleCollapseClick()
          }
        }}
        aria-expanded={collapseOpen}
        aria-label="Toggle comments section">
        <div className="col-lg-6 mb-24 d-flex align-items-center justify-content-between">
          <span className="s-booking-form__form-group__title">
            {dictionary.commentsLabel}
          </span>
          <div className="d-lg-none ">
            <i
              className={`icon-arrow-down arrow ${collapseOpen ? 'open' : ''}`}
            />
          </div>
        </div>
        <div className="col-lg-6 d-flex justify-content-lg-end align-items-end mb-24">
          <span className="s-booking-form__form-group__required">
            {dictionary.commentsRequiredLabel}
          </span>
        </div>
      </div>
      <Collapse in={collapseOpen}>
        <Comments
          name="comments"
          label={dictionary.commentsPlaceholder}
          control={control}
          error={errors.comments}
        />
      </Collapse>
    </div>
  )
})

CommentsSection.displayName = 'CommentsSection'

export default CommentsSection
